import React from "react";
import { useNavigate } from "react-router-dom";
import { useApi } from "../../hooks/useApi";
import { API_ENDPOINTS } from "../../api/endpoints";
import { AppointmentData } from "../../utils/dummyData";
import Loader from "../../components/Loader/Loader";
import ErrorMsg from "../../components/ErrorMsg/ErrorMsg";
import styles from "./Appointments.module.css";

export default function Appointments() {
  const navigate = useNavigate();
  const { response, loading, error } = useApi(
    API_ENDPOINTS.HOME_APPOINTMENTS_ANNOUNCEMENTS
  );
  const apiData = response?.appointmentsAnnouncements ?? AppointmentData;
  const [leftCard, ...rightCards] = apiData;
  return (
    <section className={styles.appointments}>
      <div className={styles.container}>
        <h3>
          Appointments <span>& Announcements</span>
        </h3>

        <div className={styles.cards}>
          {loading ? (
            <Loader />
          ) : error ? (
            <ErrorMsg />
          ) : (
            <>
              {/* Left Column */}
              <div className={styles.leftContent}>
                <article className={styles.card}>
                  <figure>
                    <img
                      src={
                        `${process.env.REACT_APP_ASSETS_BASE_URL || "https://api.imparc.site/assets/uploads/"}` +
                        leftCard.image
                      }
                      alt={leftCard.title}
                    />
                  </figure>
                  <div className={styles.content}>
                    <h4>{leftCard.title}</h4>
                    <p>{leftCard.short_desc}</p>
                    <button onClick={() => navigate("/governance")}>
                      View Details
                    </button>
                  </div>
                </article>
              </div>

              {/* Right Column */}
              <div className={styles.rightContent}>
                {rightCards.slice(0, 3).map((item, index) => (
                  <article className={styles.card} key={index}>
                    <figure>
                      <img
                        src={
                          `${process.env.REACT_APP_ASSETS_BASE_URL || "https://api.imparc.site/assets/uploads/"}` + item.image
                        }
                        alt={item.title}
                      />
                    </figure>
                    <div className={styles.content}>
                      <h4>{item.title}</h4>
                      <p>{item.short_desc}</p>
                      <button onClick={() => navigate("/governance")}>
                        View Details
                      </button>
                    </div>
                  </article>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
